<script setup>
import { useUserStore } from './../authentication/user.store'
const userStore = useUserStore()
const subscribeUrl = 'https://goalbook.com/toolkit-info-2/#plans'
const toolkitBaseUrl = import.meta.env.VITE_TOOLKIT_URL
const subscribeUniversityUrl = `${toolkitBaseUrl}/subscribe/university`
const shareUrl = `${toolkitBaseUrl}/share`
</script>
<template>
  <div class="relative max-w-44 rounded-b-sm bg-orange-50 px-4 py-2 text-base-defaultText shadow-md border border-orange-200">
    <span
      v-if="
        (userStore.isTrial && userStore.daysLeftInLicense > 0) || userStore.isEnterpriseEndingSoon
      "
      class="mb-2 flex items-center justify-center"
    >
      <p class="mr-3 text-display-lg">{{ userStore.daysLeftInLicense }}</p>
      <p class="text-sm">days<br />remaining</p>
    </span>
    <p v-if="userStore.isIndividual && userStore.isPremium && userStore.isLicenseExpired">
      <span>Subscription ended</span>
    </p>
    <p v-if="userStore.isEnterpriseEndingSoon" class="mb-3 text-wrap text-center text-sm leading-4">
      {{
        userStore.isMultiyear
          ? "Your license will be updated when your organization's multiyear renewal process is complete"
          : 'Please contact your administrator to renew your district membership'
      }}
    </p>
    <p
      v-if="
        (userStore.isTrial && !userStore.universityPartnership) ||
        (userStore.isIndividual && userStore.isPremium)
      "
      class="mb-1.5 mt-2.5 text-center text-sm"
    >
      <a :href="subscribeUrl" class="hover:underline">View Plans</a>
    </p>
    <p v-if="userStore.isTrial && userStore.universityPartnership" class="text-center text-sm">
      <a :href="subscribeUniversityUrl" class="hover:underline">University Membership</a>
    </p>
    <p class="text-center text-sm">
      <a :href="shareUrl" class="hover:underline">Share Toolkit</a>
    </p>
  </div>
</template>
<style scoped></style>
